import { useEffect, useState } from "react";
import api from "@/lib/api";

// Cached manufacturers list — shared across pages so we don't refetch on
// every navigation. Invalidate by importing `invalidateManufacturers()`
// after admin creates/edits one.
let _cache = null;
let _inflight = null;
const _subs = new Set();

async function _fetch() {
  if (_inflight) return _inflight;
  _inflight = (async () => {
    try {
      const { data } = await api.get("/manufacturers");
      _cache = Array.isArray(data) ? data : [];
    } catch {
      _cache = [];
    } finally {
      _inflight = null;
      _subs.forEach((s) => s(_cache));
    }
    return _cache;
  })();
  return _inflight;
}

export function invalidateManufacturers() {
  _cache = null;
  _fetch();
}

export default function useManufacturers() {
  const [rows, setRows] = useState(_cache || []);

  useEffect(() => {
    const onChange = (r) => setRows(r || []);
    _subs.add(onChange);
    if (_cache) setRows(_cache);
    else _fetch();
    return () => { _subs.delete(onChange); };
  }, []);

  return rows;
}
